<div *ngIf="showAppShell()">
  <app-sidebar></app-sidebar>
  <app-header></app-header>
</div>

<div class="main-content" [class.sidebar-open]="isOpen$ | async">
  <router-outlet></router-outlet>
  <app-upload-panel></app-upload-panel>
</div>
